/**
 * Employee management API (active tenant). Invite-only onboarding: admins add
 * employees; there is no open self-registration into an existing company. Backed by
 * the BFF, which orchestrates Keycloak (Organization membership + roles).
 */
import { apiClient } from '@/shared/api';

export type EmployeeRole = 'OWNER' | 'ADMIN' | 'MANAGER' | 'STAFF';
export type EmployeeStatus = 'ACTIVE' | 'INVITED' | 'DISABLED';

export interface Employee {
  id: string;
  name: string | null;
  email: string;
  role: EmployeeRole;
  status: EmployeeStatus;
}

export interface InviteEmployeeRequest {
  email: string;
  role: EmployeeRole;
}

const BASE = '/api/v1/employees';

export const listEmployees = async (): Promise<Employee[]> =>
  (await apiClient.get<Employee[]>(BASE)).data;

export const inviteEmployee = async (body: InviteEmployeeRequest): Promise<Employee> =>
  (await apiClient.post<Employee>(`${BASE}/invitations`, body)).data;

export const changeEmployeeRole = async (id: string, role: EmployeeRole): Promise<Employee> =>
  (await apiClient.put<Employee>(`${BASE}/${id}/role`, { role })).data;

export const deactivateEmployee = async (id: string): Promise<void> => {
  await apiClient.delete(`${BASE}/${id}`);
};
